import { useQuery, useQueryClient } from '@tanstack/react-query'
import { getIO } from '../shared/_api'

export const investQueryKeyRoot = ['invest'] as const

export const getInvestRouteId = () => window.location.pathname.split('/')[2]

export const getInvestQueryKey = (id = getInvestRouteId()) =>
  [...investQueryKeyRoot, id] as const

export const useInvestDataState = () => {
  const id = getInvestRouteId()
  const queryClient = useQueryClient()

  return useQuery({
    queryKey: getInvestQueryKey(id),
    queryFn: async () => {
      const data = await getIO(id)
      const overrideData = queryClient.getQueryData(['overrideData']) || {}
      return {
        ...data,
        ...overrideData,
      }
    },
    enabled: !!id && window.location.pathname.includes('invest/'),
    refetchOnWindowFocus: 'always',
    staleTime: Infinity,
  })
}
